import React, { PropsWithChildren } from 'react'

import styles from './ContentLoader.module.scss'
import { Preloader } from '../../../../../shared/components/cards/preloader/Preloader'
import clsx from 'clsx'

export interface ContentLoaderProps {
  loading?: boolean
}

export const ContentLoader = ({ children, ...props }: PropsWithChildren<ContentLoaderProps>) => {
  const { loading = false } = props

  return (
    <div className={clsx(styles.wrapper, { [styles.loading]: loading })}>
      <div className={styles.content}>{children}</div>
      <div className={styles.loader}>
        <Preloader />
      </div>
    </div>
  )
}
